module.exports = __webpack_public_path__ + "img/bannercontato.b6588298.jpg";